import { render, staticRenderFns } from "./franchise-qty-store.vue?vue&type=template&id=c72c03e0"
import script from "./franchise-qty-store.vue?vue&type=script&lang=js"
export * from "./franchise-qty-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports